module.exports = __webpack_public_path__ + "img/error-solid.96d75900.svg";